module.exports = __webpack_public_path__ + "static/media/icon_tick_modal.ca4cb059.svg";